import { Patient } from "@/@types/sintegrada/Patient";
import { sintegradaApi } from "@/services/api";

export type DeadPatientsParams = {
	uf: string;
	ibgeCode: string;
	startDate: string;
	endDate: string;
	cnes?: string;
	youngerAge?: number;
	olderAge?: number;
	professionalId?: number;
	professionalCns?: string;
	professionalName?: string;
};

export async function getDeadPatients({ uf, ibgeCode, ...params }: DeadPatientsParams) {
	const response = await sintegradaApi.get<Patient[]>(
		`/uf/${uf}/city/${ibgeCode}/patient/dead-patients`,
		params
	);
	return response.data || [];
}
